import Textarea from 'erxes-ui/lib/components/form/Textarea';

export default Textarea;
